import React from "react";
import SwitcherMapMode from "./SwitcherMapMode";
import img from '../../../../../assets/images/busto.svg';
import { useSelector } from "react-redux";
import { RootState } from "@/store/redux/store";
import useMode from "../../../hooks/useMode";

const SwitcherBusStop = () => {
    const mode = useSelector((state: RootState) => state.mapScreen.mapMode);
    const { onBusStopMode } = useMode();
    return (
        <SwitcherMapMode
            type='busStops'
            img={img}
            text="Остановки"
            isActive={mode === 'busStops'}
            onClick={onBusStopMode}
        />
    )
}

export default SwitcherBusStop;